<stages-dialog2 [dialogAriaLabel]="'files.cms.oauth.success' | translate" #dialog
	><stages-dialog-header />
	<span class="h1" translate="files.cms.oauth.success"></span>
	<p class="panel" translate="files.cms.oauth.success.standby"></p>
	<stages-spin size="md" />
	<footer></footer>
</stages-dialog2>
